export default {
  toasts: {
    failed_to_save_changes: 'Erro ao guardar as alterações.',
    successfully_saved: 'Guardado com sucesso.',
  },
  form: {
    has_multiple_locations: {
      label: 'Definir localizações diferentes para a semana',
    },
  },
  labels: {
    day_location: '{{day}} - localização {{index}}',
    selected_days: 'Dias selecionados',
    orders_paused: 'Encomendas pausadas',
    open_time: 'Hora de abertura',
    close_time: 'Hora de fecho',
  },
  buttons: {
    save: 'Guardar',
  },
};
